import Config from '../../services/config';
import { BettingAPI } from "../../services/api/betting-api";
import CasinoService, { NEW_CASINO } from '../../services/casino-feed';

Config.title = 'KobaBet - Ethiopian Sports Betting & Games';
Config.logourl = require('url:./assets/img/logo-kobabet.svg');
Config.softionAPI = 'https://api-new.koba.bet';
Config.softionLiveAPI = 'wss://api-new.koba.bet/ws/live-feed';
Config.softionAccountsAPI = false; // "https://user.megawin.casino?lang=fr&softionAPI=" + encodeURIComponent('https://api.jektissbet.com') + "&softionLiveAPI=" + encodeURIComponent('wss://live-2.betfire.com/live-feed');
Config.softionLiveTrackerAPI = (trackerid, lang) => 'https://seven-plugin-scout.7platform.com/?lang='+ lang +'&company=default&mode=simple#'+ trackerid;
Config.ticketPrintAPI = Config.softionAPI+"/wadmin/index.php?controller=ticketprint&module=ticket&popup&ticketid=";
Config.reservedPrintAPI = Config.softionAPI+"/wadmin/index.php?controller=ticketprint&module=reserved&ticketid=";
Config.defaultLanguage = 'en';
Config.lang = Config.defaultLanguage;
Config.AccountApiClass = new BettingAPI();
Config.defaultCurrency = 'ETB';
Config.userMenuAsPopup = true;
Config.publickey = "kobabet";
Config.requireOTP = true;
Config.telegramLogin = "8623872770"; // clientid per TelegramButton

/* Abilita o disabilita il cashout parziale e il cashout automatico */
Config.partialcashout = true;
Config.allowP2P = false;
Config.allowManualDeposit = false;
Config.allowManualWithdraw = true;

Config.hideHeader = false;
Config.hideFooter = false;

Config.customConfig = {
	hideProvidersLogos: true,

 	// Dal widget eventi in partenza rimuove queste categorie:
 	nextEventsHideCategory: [/*'/category/1/1517'*/], // calcio cyber

	// homeWidgets può consentire di gestire il contenuto della home in stile CMS
	// Mi serve solo per scegliere se mostrare il carosello o la lista eventi al momento
	// ma preferisco preparare un sistema più sofisticato ora piuttosto che trovarmi
	// con 100 booleani e poi scoprire che devo anche ordinare i widget
	homeWidgets: [
		{name:'carousel'},
		{name:'live-preview'}, // Non prevedo di usarlo per ora
		{name:'last-minute'}, // Non prevedo di usarlo per ora
		{name:'most-played'}, // Non prevedo di usarlo per ora
	]
};

Config.getPreferredHomeWidgets = () => {
	if (!!Config.skinConfig && !!Config.skinConfig.homeWidgets)
		return Config.skinConfig.homeWidgets;
	return Config.customConfig.homeWidgets;
}

const MATCHREEL_HOME = [
	{name:'match-reel'},
	{name:'live-preview'}, // Non prevedo di usarlo per ora
	{name:'last-minute'}, // Non prevedo di usarlo per ora
	{name:'most-played'}, // Non prevedo di usarlo per ora
];

const SKIN_CONFIG = {
};

Config.setSkin = (publicKey) => {
	Config.skinConfig = {
		// LTN only
		// bannersUrl: Config.softionAPI.replace('https://api-new.', 'https://www.')+'/personalApp/banners/personalizableBanners/json/bannerList.json',
		// bannersDomain: Config.softionAPI.replace('https://api-new.', 'https://www.')+'/personalApp/banners/personalizableBanners/file',
		...(SKIN_CONFIG[publicKey] || {})
	};
	if (!!Config.skinConfig.defaultOddsFormat) {
		Config.betting['odds-format'] = Config.skinConfig.defaultOddsFormat;
	}
	if (!!Config.skinConfig.translations) {
		// window.i18n._activeMessages è un monkey-patch per aggiungere/modificare traduzioni su jsLingui.
		// Modificare il catalogo a posteriori non funziona perché lingui si fa una copia 1:1 del catalogo
		// Quindi mofico la sua rappresentazione interna delle traduzioni per farlo funzionare
		Object.assign(window.i18n._activeMessages, Config.skinConfig.translations)
	}
};

CasinoService.INSTANCE = NEW_CASINO;

export default Config;
